/* Copyright (c) 2020-present CloudIO Inc */

import { PivotGridConfiguration } from '@cloudio-saas/datasource-types';

export const DefaultPivotGridConfiguration: PivotGridConfiguration = {
  rows: [],
  columns: [],
  aggregates: [],
  defaultRowExpandLevel: 1,
  defaultColumnExpandLevel: 1,
};
